import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/home/vantage/htdocs/www.vantagediesel.com/components/ui/separator.jsx");
;
import(/* webpackMode: "eager" */ "/home/vantage/htdocs/www.vantagediesel.com/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/vantage/htdocs/www.vantagediesel.com/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/vantage/htdocs/www.vantagediesel.com/node_modules/next/font/google/target.css?{\"path\":\"app/locations/[city]/page.js\",\"import\":\"Oswald\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"weight\":\"200\"}],\"variableName\":\"oswald\"}");
